import { useEffect, useState } from 'react'
import './styles.css'


export default function ScrollBar() {

    let [scroll, setScroll] = useState(0);

    let thumb = document.querySelector('.thumb');
    let scrollHeight = document.documentElement.scrollHeight;
    let clientHeight = document.documentElement.clientHeight
    let positionThumbTop;
    let percentage = (scroll / (scrollHeight - clientHeight) * 100)

    window.addEventListener("mouseup", () => {
        document.onmousemove = null;

    })

    
    let handleEvent = (event) => {
        document.onmousemove = (event) => {
            if(event.clientY > clientHeight * (0.50 - 127) && event.clientY < (200 + clientHeight * (0.50))){
                console.log(event)
                    
                document.documentElement.scrollTop = (((event.clientY - 227) / 2) * (scrollHeight - clientHeight) / 100)
            
            }
                
        }
        event.preventDefault()

        
    }
        

    useEffect(() => {
        if(!thumb && !positionThumbTop) positionThumbTop = document.querySelector(".thumb").style.top
        const onScroll = () => setScroll(document.documentElement.scrollTop);
        window.removeEventListener('scroll', onScroll);
        window.addEventListener('scroll', onScroll, { passive: true });

        return () => window.removeEventListener('scroll', onScroll);

    }, [scroll]);

    return (
        <div className="slider" style={{ top: "calc(50% - 100px)", height: "200px"  }}>
            <div id="1" 
                className="thumb"
                style={{ top: `${percentage * 2 - 7}px` }}
                onMouseDown={ handleEvent }
            >
            </div>
        </div>
    )

}